const hasResults = (pageResults, suggestions, vehicles) => {
	return (
		pageResults?.length > 0 ||
		suggestions?.length > 0 ||
		vehicles?.length > 0
	);
};

export default hasResults;
